import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import classes from "./badge.module.scss";
export type BadgeProps = {
  /** Badge text */
  title: string;
  /** Optional leading icon, sized to the badge text */
  icon?: React.ReactNode;
  /** Background colour — any CSS colour value or token */
  color: string;
  className?: string;
};
export function Badge(t0) {
  const $ = _c(11);
  const {
    title,
    icon,
    color,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn(classes.badge, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== color) {
    t2 = {
      backgroundColor: color
    };
    $[2] = color;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== icon) {
    t3 = icon && <span className={classes.icon}>{icon}</span>;
    $[4] = icon;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== title) {
    t4 = <span data-slot="badge" className={t1} style={t2}>{t3}{title}</span>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = title;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}